import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { defineAsyncComponent, markRaw, ref, watch } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'IndexView',
  props: {
    version: {}
  },
  setup(__props: any) {

const props = __props;

const comp = ref(null);

function loadComponent(version?: string) {
  return defineAsyncComponent(() =>
    import(`./${version ?? "v1.0.0"}/DocView.vue`)
      .then((mod) => mod.default)
      .catch(() =>
        import("./v1.0.0/DocView.vue").then((mod: any) => mod.default)
      )
  );
}

watch(
  () => props.version,
  (newVersion) => {
    comp.value = markRaw(loadComponent(newVersion));
  },
  { immediate: true }
);

// 申明name

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(comp.value)))
}
}

})